import React, { Component } from 'react';
import * as $ from 'jquery';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { SCREEN_WIDTH } from '../App.js';
import { compose } from 'recompose';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router-dom';

let cancelToken;
let state;
let tokenSession;

export const MENU = {
  EVENTS: 1,
  ASSISTANT: 2,
  HISTORY: 3,
  RESERVATIONS: 4,
  TICKETS: 5,
  INVOICES: 6,
  PROFILE: 7,
  LOCATIONS: 8,
  CONTACT: 9,
  SDELIVERY: 10,
  PROMOCODE: 11,
  MARKETPLACE: 12,
  BENEFIT: 13
};

export const MENU_STATUS = {
  SHOW: 1,
  HIDE: 2,
  MESSAGE: 3,
  HIDE_FUNCTION: 4
};

class Sidebar extends Component {

  constructor(props) {
    super(props);
    if (tokenSession !== props.getTokenSession()) {
      state = this.getInitState();
    }
    this.state = state;
  }

  componentWillMount() {
    cancelToken = axios.CancelToken.source();
  }

  componentDidMount() {
    $('.sidebar-nav a').on('click', () => {
      if ($(window).width() <= SCREEN_WIDTH.SMALL) {
        $('.navbar-collapse').collapse('hide');
      }
    });
    this.reload();
  }

  componentWillUnmount() {
    state = this.state;
    cancelToken.cancel('Component will unmount.');
    tokenSession = this.props.getTokenSession();
  }

  didGetProfile = (response) => {
    this.setState({ unreadNotifications: response.unread_notifications });
    this.props.setUser(Object.assign({},
      this.props.user,
      { center_id: response.center_id ? response.center_id : "1"},
      { center_name: response.center_name ? response.center_name : "TORRES IOS CAMPESTRE"},
      { ios_express: response.ios_express },
      { balance: response.balance },
      { contactEmail: response.contact_email },
      { credits: response.credits },
      { memberId: response.member_id },
      { company: response.company },
      { notificaciones: response.notificaciones },
      { phone: response.phone })
    );
  }

  getInitState = () => {
    return ({ unreadNotifications: 0 });
  }

  getProfile = (params) => {
    this.props.post(
      "/getProfile",
      params,
      (response) => this.didGetProfile(response),
      (error) => this.props.handleErrorResponse(error),
      cancelToken
    );
  }

  isItemHidden = (itemId) => {
    const permissions = this.props.user.permissions;
    const itemStatus = permissions.filter((item) => item.id === itemId)[0];
    return itemStatus && itemStatus.status === MENU_STATUS.HIDE ? "hidden" : "";
  }

  isLinkActive = (pathname) => {
    return this.props.location.pathname.includes(pathname) ? "active" : "";
  }

  reload = () => {
    this.getProfile({
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession()
    });
  }

  render() {
    const unread = this.state.unreadNotifications;
    const { t } = this.props;
    return (
      <div className="navbar-default sidebar" role="navigation">
        <div className="collapse navbar-collapse sidebar-nav">
          <ul className="nav" id="side-menu">
            <li className={this.isItemHidden(MENU.PROFILE)}>
              <Link className={this.isLinkActive("/profile")} to="/profile">
                <div className="profile">
                  <img className="img-circle img-responsive media-object" alt={t('dashboard.navbar.img_user')} src={this.props.user.picture} />&nbsp;
                  <span className="">
                    {this.props.user.name + " " + this.props.user.lastname}
                  </span>
                </div>
              </Link>
            </li>
            <li className={this.isItemHidden(MENU.MARKETPLACE)}>
              <Link className={this.isLinkActive("/marketplace")} to="/marketplace">
                <i className="fa fa-fw fa-comments" />&nbsp;
                {t('dashboard.sidebar.marketplace')}
              </Link>
            </li>
            {/* <li className={this.isItemHidden(MENU.ASSISTANT)}>
              <Link className={this.isLinkActive("/profile/myconnections")} to="/profile/myconnections">
                <i className="fa fa-users" aria-hidden="true" />&nbsp;
                {t('dashboard.sidebar.connection')}
              </Link>
            </li> */}
            <li className={this.isItemHidden(MENU.EVENTS)}>
              <Link className={this.isLinkActive("/events")} to="/events">
                <i className="fa fa-fw fa-calendar" />&nbsp;
                {t('dashboard.sidebar.events')}
              </Link>
            </li>
            <li className={this.isItemHidden(MENU.ASSISTANT)}>
              <Link className={this.isLinkActive("/assistant")} to="/assistant">
                <i className="fa fa-fw fa-bell" />&nbsp;
                {t('dashboard.sidebar.assistant')}
                <span className={unread > 0 ? "" : "hidden"}>
                  <span className="notification-badge">{unread > 99 ? 99 : unread}</span>
                </span>
              </Link>
            </li>
            <li className={this.isItemHidden(MENU.HISTORY)}>
              <Link className={this.isLinkActive("/history")} to="/history">
                <i className="fa fa-fw fa-clock-o" />&nbsp;
                {t('dashboard.sidebar.history')}
              </Link>
            </li>
            {/* <li className={this.isItemHidden(MENU.HISTORY)}>
              <Link className={this.isLinkActive("/cowork")} to="/cowork">
                <i className="fa fa-fw fa-clock-o" />&nbsp;
                Mis Coworks
              </Link>
            </li> */}
            <li className={this.isItemHidden(MENU.RESERVATIONS)}>
              <Link className={this.isLinkActive("/reservations")} to="/reservations">
                <i className="fa fa-fw fa-building" />&nbsp;
                {t('dashboard.sidebar.reservations')}
              </Link>
            </li>
            <li className={this.isItemHidden(MENU.TICKETS)}>
              <Link className={this.isLinkActive("/tickets")} to="/tickets">
                <i className="fa fa-fw fa-tags" />&nbsp;
                {t('dashboard.sidebar.tickets')}
              </Link>
            </li>
            {/* <li className={this.isItemHidden(MENU.ASSISTANT)}>
              <Link className={this.isLinkActive("/conection")} to="/iosconection">
                <i className="fa fa-search" aria-hidden="true" />&nbsp;&nbsp;
                {t('dashboard.sidebar.searchConnection')}
              </Link>
            </li> */}
            <li className={this.isItemHidden(MENU.INVOICES)}>
              <Link className={this.isLinkActive("/invoices")} to="/invoices">
                <i className="fa fa-fw fa-credit-card" />&nbsp;
                {t('dashboard.sidebar.invoices')}
              </Link>
            </li>
            <li className={this.isItemHidden(MENU.LOCATIONS)}>
              <Link className={this.isLinkActive("/locations")} to="/locations">
                <i className="fa fa-fw fa-globe" />&nbsp;
                {t('dashboard.sidebar.locations')}
              </Link>
            </li>
            <li className={this.isItemHidden(MENU.CONTACT)}>
              <Link className={this.isLinkActive("/contact")} to="/contact">
                <i className="fa fa-fw fa-address-card" />&nbsp;
                {t('dashboard.sidebar.contact')}
              </Link>
            </li>
            <li className={this.isItemHidden(MENU.SDELIVERY)}>
              <Link className={this.isLinkActive("/sdelivery")} to="/sdelivery">
                <i className="fa fa-fw fa-paper-plane" />&nbsp;
                {t('dashboard.sidebar.sdelivery')}
              </Link>
            </li>
            <li className={this.isItemHidden(MENU.ASSISTANT)}>
              <Link className={this.isLinkActive("/promocode")} to="/promocode">
                <i className="fa fa-gift" />&nbsp;
                {t('dashboard.sidebar.promocode')}
              </Link>
            </li>
            <li className={this.isItemHidden(MENU.BENEFIT)}>
              <Link className={this.isLinkActive("/benefit")} to="/benefit">
                <i className="fa fa-star-o" />&nbsp;
                {t('dashboard.sidebar.benefits')}
              </Link>
            </li>
            <li className="movil_container">
              <a href="https://www.iosoffices.com/lifestyle" rel="noopener noreferrer" target="_blank">
                <i className="glyphicon glyphicon-book" />&nbsp;
                {t('dashboard.navbar.lifestyle')}
              </a>
            </li>
            <li className="movil_container">
              <Link to="/mejoracontinua" rel="noopener noreferrer" target="_blank">
                <i className="fa fa-fw fa-pencil-square-o" />&nbsp;
                {t('dashboard.navbar.survey')}
              </Link>
            </li>
            <li className="movil_container">
              <a onClick={this.props.handleLogoutClick}>
                <i className="fa fa-fw fa-sign-out" />&nbsp;
                {t('dashboard.navbar.logout')}
              </a>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

export default compose(
  translate('common'),
  withRouter
)(Sidebar);



// WEBPACK FOOTER //
// ./src/dashboard/Sidebar.js